import Dialog from '@mui/material/Dialog';
import useMediaQuery from '@mui/material/useMediaQuery';

import { useTheme } from '@mui/material/styles';

import { StyledContainer } from './style';

type TAlertProps = {
  title: string;
};

const index = ({ title }: TAlertProps) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open
      maxWidth="xl"
      fullScreen={fullScreen}
      PaperProps={{
        style: {
          backgroundColor: 'rgba(34, 43, 58, 0.8)',
          border: fullScreen ? 'none' : '4px solid white',
          color: 'white',
        },
      }}
    >
      <StyledContainer>
        <h2 dangerouslySetInnerHTML={{ __html: title }} />
      </StyledContainer>
    </Dialog>
  );
};

export default index;
